import { render } from "./Admissions.vue?vue&type=template&id=4c761d02&scoped=true&ts=true"
import script from "./Admissions.vue?vue&type=script&lang=ts"
export * from "./Admissions.vue?vue&type=script&lang=ts"

import "./Admissions.vue?vue&type=style&index=0&id=4c761d02&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c761d02"]])

export default __exports__